import {
	Component,
	OnInit,
	Input,
	ViewEncapsulation,
	ViewChild,
	ElementRef,
	Output,
	EventEmitter,
	SimpleChanges,
	OnDestroy,
	OnChanges,
	ChangeDetectorRef,
	HostListener
} from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { PopoverService } from '../../shared/services/popover.service';
import { TIconType } from '../icon/icon.types';
import { TTooltipPosition, TTooltipPositionX } from '../tooltip/tooltip.types';

@Component({
	selector: 'rbc-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss'],
	providers: [PopoverService],
	encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit, OnDestroy, OnChanges {
	@Input() active: boolean;
	@Input() clickable: boolean = true;
	@Input() hover: boolean = false;
	@Input() icon: string;
	@Input() iconWeight: TIconType = 'regular';
	@Input() id: string;
	@Input() labelTrigger: string = 'toggle menu';
	@Input() position: TTooltipPosition = 'bottom';
	@Input() positionX: TTooltipPositionX = 'center';
	@Input() absolute: boolean = false;

	@Output() popovertoggle = new EventEmitter();

	@ViewChild('self') self: ElementRef;
	@ViewChild('content') content: ElementRef;

	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this.eRef.nativeElement.contains(event.target) && this.isOpen) {
			this.isOpen = false;
			this.cdr.markForCheck();
		}
	}

	@HostListener('document:touchend', ['$event'])
	touchend(event) {
		if (!this.eRef.nativeElement.contains(event.target) && this.isOpen) {
			this.isOpen = false;
			this.cdr.markForCheck();
		}
	}

	get isOpen(): boolean {
		return this.popoverService.isOpen || this.active;
	}
	set isOpen(change: boolean) {
		this.popoverService.isOpen = change;
	}

	constructor(
		private idService: IdService,
		private popoverService: PopoverService,
		private cdr: ChangeDetectorRef,
		private eRef: ElementRef
	) {
		this.id = idService.generate();
	}

	ngOnInit() {
		this.popoverService.syncProps({
			clickable: this.clickable,
			active: this.active,
			hover: this.hover,
			position: this.position,
			positionX: this.positionX,
			offset: 10,
			triggerRef: (this.self.nativeElement as HTMLElement).firstElementChild,
			popoverRef: this.content.nativeElement
		});

		// sync with isOpen changes in service
		// if (this.popoverService.$popoverToggle) {
		// 	this.popoverService.$popoverToggle.subscribe(change => {
		// 		this.isOpen = change;
		// 	});
		// }
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);

		// ensure menu is fully removed
		this.isOpen = false;
	}

	// If active imput changes set isOpen to active and popoverService active
	ngOnChanges(changes: SimpleChanges): void {
		if (changes) {
			if (changes.active) {
				this.popoverService.active = changes.active.currentValue;
				this.isOpen = this.active;
			}
		}
	}

	// Toggle the menu and emit an event of its current visibility
	toggle(event) {
		// this.popoverService.$_Popover_toggle(event, this.content);
		this.isOpen = !this.isOpen;
		this.popovertoggle.emit(this.isOpen);
	}

	hoverToggle(toggle: boolean) {
		// this.popoverService.$_Popover_hoverToggle(toggle);
		if (this.hover) {
			setTimeout(() => {
				this.isOpen = toggle;
				this.cdr.markForCheck();
				// this.$_Popover_reset();
			}, 250);
		}
	}

	classGen() {
		const classes = [];
		if (this.position) {
			classes.push(`menu-${this.position}`);
		}
		if (this.positionX === 'left') {
			classes.push('menu-flush-left');
		}
		if (this.positionX === 'right') {
			classes.push('menu-flush-right');
		}
		return classes;
	}
}
